<template>
  <div class="map-wrapper">
    <GmapMap
      ref="mapRef"
      :center="{lat:48.8577392, lng:2.3365915}"
      :zoom="16"
      class="map"
      map-type-id="terrain"
    />
  </div>
</template>


<script>
import { gmapApi } from 'vue2-google-maps';
import axios from 'axios';
import MarkerImg from '@/assets/images/gmaps_marker.png';

export default {
  props: {
    results: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      map: null,
    };
  },
  computed: {
    google: gmapApi,
  },
  watch: {
    results() {
      this.map.setCenter(this.results[0].geometry.location);
      const coords = this.results[0].geometry.location;
      this.map.setCenter(coords);
      this.map.setZoom(13);
      const populationOptions = {
        strokeColor: '#0000ff',
        strokeOpacity: 0.5,
        strokeWeight: 2,
        fillColor: '#0000ff',
        fillOpacity: 0.15,
        map: this.map,
        center: coords,
        radius: parseInt(2 / 0.001, 0),
      };
      if (this.areaPath) this.areaPath.setMap(null);
      this.areaPath = new this.google.maps.Circle(populationOptions);
    },
  },
  mounted() {
    this.$refs.mapRef.$mapPromise.then((map) => {
      this.map = map;
      this.loadMarkers();
    });
  },
  methods: {
    async loadMarkers() {
      try {
        const result = await axios.get(`${this.$store.state.basePath}/assets/stores.csv`);
        this.parseData(result.data);
      } catch (e) {
        console.info('ERROR LOADING MAP DATA');
      }
    },
    parseData(data) {
      const arraydata = data.split(/\r?\n/);
      let currentsplit;
      let myLatlng;
      let marker;
      let i = 0;
      const length = arraydata.length;
      let title = '';
      this.infoWindow = new this.google.maps.InfoWindow({
        content: 'Chargement...',
      });
      for (i = 1; i < length; i += 1) {
        if (arraydata[i] === '') break;
        currentsplit = arraydata[i].split('|');
        myLatlng = new this.google.maps.LatLng(parseFloat(currentsplit[3].replace(',', '.')), parseFloat(currentsplit[4].replace(',', '.')));
        title = `<div style="color:black!important; text-transform: none; max-width:250px" title=""><strong>${currentsplit[0]}</strong><br/><span>${currentsplit[1]}</span><br/><em style="font-style: italic">${currentsplit[2]}</em></div>`;
        marker = new this.google.maps.Marker({
          position: myLatlng,
          content: title,
          infoWindowIndex: i,
          icon: MarkerImg,
          optimized: true,
        });
        this.addRollOverMarker(marker);
        marker.setMap(this.map);
        // this.markers.push(marker);
      }
    },
    addRollOverMarker(marker) {
      this.google.maps.event.addListener(marker, 'mouseover', () => {
        this.infoWindow.setContent(marker.content);
        this.infoWindow.open(this.map, marker);
      });
    },
  },
};
</script>
<style lang="stylus">
.vue-map {
  border-radius: 6px;
  border: 1px solid $cl-yellow;
}
</style>

<style lang="stylus" scoped>
.map-wrapper {
  width: 100%;
  height: 100%;
  .map {
    width: 100%; height: 100%;
    border-radius: 6px;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  }
}
</style>
